// Module
var code = `<div appHeaderBar><header-bar-title>Payment History</header-bar-title></div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header *ngIf="property"
                        [property]="property.nickname"
                        [manager]="property.hoa.pmc.name"
                        [association]="property.hoa.name">
    </app-cobrand-header>

    <div class="HOA-container" *ngIf="paymentHistory">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text" tid="paymentHistoryHeader">Payment History</h1>
        </div>
        <div class="HOA-container__content">
            <app-payment-history
                    [paymentHistory]="paymentHistory"
                    [property]="property"
                    [limit]="1000">
            </app-payment-history>
            <div class="HOA-Checking-Detail-button-container">
                <button name="cancel" id="back" tid="back" type="button" class="Button Button--link" (click)="goBack()">Back</button>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;